import EventEmitter from 'events';
import magic from '../magic';

// UI compatibility facade. CANopen transactions now run on LilyGO, not in the app.
export function createCanopen(api=magic,{discover=true}={}) {
  const client={
    eventEmitter:new EventEmitter(),nodes:new Map(),initialized:false,
    readSDO:(node,index,sub)=>api.readSDO(node,index,sub),
    writeSDO:(node,index,sub,data)=>api.writeSDO(node,index,sub,data),
    init(){if(!this.initialized){api.bleEventDispatcher.on('raw',onFrame);this.initialized=true;}},
    cleanup(){api.bleEventDispatcher.removeListener('raw',onFrame);this.initialized=false;this.nodes.clear();},
  };
  function onFrame({id,payload,timestamp}){
    if(!discover||id<0x701||id>0x77f||payload.length!==1)return;
    const nodeId=id-0x700;
    let node=client.nodes.get(nodeId);
    if(!node){
      node={id:nodeId,name:`Node ${nodeId}`,lastSeen:timestamp};client.nodes.set(nodeId,node);
      client.eventEmitter.emit('node-discovered',node);
      client.readSDO(nodeId,0x1008,0).then(bytes=>{
        if(client.nodes.get(nodeId)!==node)return;
        node.name=new TextDecoder().decode(bytes).replace(/\0+$/,'');
        client.eventEmitter.emit('node-name-updated',{nodeId,name:node.name,node});
      }).catch(()=>{});
    }
    node.lastSeen=timestamp;
  }
  return client;
}
export default createCanopen();
